export const FILTERS_LIMIT = 100;
export const COMPANY_FILTER_LIMIT = 150;
